import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import userImage from "../../src/assets/img/user.png";
import {
  Col,
  Row,
  Button,
  Form,
  Image,
  Card,
} from "@themesberg/react-bootstrap";

import { getUserProfile, updateUserProfile } from "../app/api";
import axios from "axios";
import Loader from "../components/Loader";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import Loadericon from "../components/Loadericon";
export default () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zip, setZip] = useState("");
  const [country, setCountry] = useState("");
  const [userId, setUserID] = useState("");
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageLoadError, setImageLoadError] = useState(false);
  const handleImageError = () => {
    setImageLoadError(true);
  };
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]); // Store the selected file
  };
  const fetchUser = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));
      // console.log(user)
      const id = user.id;
      setUserID(id);
      const response = await axios.get(getUserProfile(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      console.log(response.data);
      setName(response.data?.name);
      setEmail(response.data?.email);
      setPhone(response.data?.phone);
      setAddress(response.data?.address);
      setCity(response.data?.city);
      setState(response.data?.state);
      setZip(response.data?.zip_code);
      setCountry(response.data?.country);
    const baseURL = "https://appvelo.com/vendormanageAPI/uploads/";
    const profileImageFilename = response.data?.profile_image;

    if (profileImageFilename) {
      const fullProfilePicURL = baseURL + profileImageFilename;
      setProfilePic(fullProfilePicURL);
    } else {
      // Handle the case where profile_image is not present in the response
      setProfilePic(null); // Or a default image URL
    }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUser();
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingBtn(true);
    try {
      const token = localStorage.getItem("token");

      // Create a FormData object
      const formData = new FormData();

      // Append all form fields to the FormData object
      formData.append("name", name);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("address", address);
      formData.append("city", city);
      formData.append("state", state);
      formData.append("zip_code", zip);
      formData.append("country", country);

      // Append the selected file if it exists
      if (selectedFile) {
        formData.append("profile_image", selectedFile);
      }

      // Send the FormData object in the request
      const response = await axios.post(updateUserProfile(userId), formData, {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
          "Content-Type": "multipart/form-data", // Set content type to multipart/form-data
        },
      });
      swal({
        text: response.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });

      // console.log(response.data);
    } catch (error) {
      swal({
        text:error.response.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoadingBtn(false);
    }
  };
  return (
    <>
      <div className="d-flex justify-content-between  flex-wrap flex-md-nowrap align-items-center mb-2">
        <div className="d-block  mb-md-0">
          <h4 className="mb-0">Settings</h4>
          {/* <p className="mb-0">Your web analytics dashboard template.</p> */}
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <Row>
          <Col xs={12} xl={12}>
            <Card border="light" className="bg-white shadow-sm mb-4">
              <Card.Body>
                <h5 className="mb-4">General information</h5>
                <Form onSubmit={handleSubmit}>
                  <Col md={6}>
                    <div className=" mb-3 d-xl-flex align-items-center">
                    {!profilePic || imageLoadError ? (
                      <div className="user-avatar xl-avatar">
              <Image fluid rounded src={userImage} alt="Default User" />
              </div>
            ) : (
              <div className="user-avatar xl-avatar">
              <Image
                fluid
                rounded
                src={profilePic}
                alt="Profile Picture"
                onError={handleImageError}
              /></div>
            )}
                      
                      <div className="file-field">
                        <div className="d-flex justify-content-xl-center ms-xl-3">
                          <div className="d-flex">
                            <span className="icon icon-md">
                              <FontAwesomeIcon
                                icon={faPaperclip}
                                className="me-3"
                              />
                            </span>
                            <input
                              type="file"
                              onChange={handleFileChange} // Handle file selection
                              accept="image/*" // Accept only image files
                            />
                            <div className="d-md-block text-start">
                              <div className="fw-normal text-dark mb-1">
                                Choose Image
                              </div>
                              <div className="text-dark small">
                                JPG, GIF or PNG. Max size of 800K
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Row>
                    <Col md={6} className="mb-3">
                      <Form.Group id="Name">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                          type="text"
                          placeholder="Enter your name"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-3">
                      <Form.Group id="phone">
                        <Form.Label>Phone</Form.Label>
                        <Form.Control
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          required
                          type="number"
                          placeholder="+12-345 678 910"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6} className="mb-3">
                      <Form.Group id="emal">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          type="email"
                          placeholder="name@company.com"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <h5 className="my-4">Address</h5>
                  <Row>
                    <Col sm={6} className="mb-3">
                      <Form.Group id="address">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                          required
                          type="text"
                          placeholder="Enter your home address"
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={6} className="mb-3">
                      <Form.Group id="Country">
                        <Form.Label>Country</Form.Label>
                        <Form.Control
                          value={country}
                          onChange={(e) => setCountry(e.target.value)}
                          required
                          type="text"
                          placeholder="Country"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={4} className="mb-3">
                      <Form.Group id="city">
                        <Form.Label>City</Form.Label>
                        <Form.Control
                          value={city}
                          onChange={(e) => setCity(e.target.value)}
                          required
                          type="text"
                          placeholder="City"
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={4} className="mb-3">
                      <Form.Group id="state">
                        <Form.Label>State</Form.Label>
                        <Form.Control
                          value={state}
                          onChange={(e) => setState(e.target.value)}
                          required
                          type="text"
                          placeholder="State"
                        />
                      </Form.Group>
                    </Col>
                    <Col sm={4}>
                      <Form.Group id="zip">
                        <Form.Label>ZIP</Form.Label>
                        <Form.Control
                          value={zip}
                          onChange={(e) => setZip(e.target.value)}
                          required
                          type="tel"
                          placeholder="ZIP"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="mt-3">
                    {loadingBtn ? (
                      <div className="d-flex justify-content-start">
                        <Loadericon />
                      </div>
                    ) : (
                      <Button variant="primary" type="submit">
                        Save All
                      </Button>
                    )}
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>

       
        </Row>
      )}
    </>
  );
};
